export default "__VITE_ASSET__DTdoEwS7__"